import React, { useEffect, useState } from 'react';
import ResultComponent from './ResultComponent';
import { Link } from 'react-router-dom';
import { getDownloadLink } from '../../Shares/CommonUtil';
import { useRecoilValue } from 'recoil';
import { cdnUrlConfig } from '../../Utils/atoms';

//Bigglz App
const KAKAO_API = "9c23f66cf88be2d5566c85739e99f808"; 

const Result = ({ resultValue }) => {
    const [popText, setPopText] = useState("");
    const [popModal, setPopModal] = useState(false)
    const cdnUrl = useRecoilValue(cdnUrlConfig);
    const IMG_URL = `${cdnUrl}/BigglzEvent`;

    useEffect(() => { //카카오 공유하기 Init
        if (window.Kakao === undefined) {
            console.log("카카오 서비스를 불러올 수 없습니다. 브라우저의 스크립트 차단 기능을 확인해주세요.")
        }
        else if (!window.Kakao.isInitialized()) {
            window.Kakao.init(KAKAO_API);
        }
    }, [])

    useEffect(() => { //팝업창 종료시 메시지 초기화
        if (!popModal) {
            setPopText("");
        }
    }, [popModal])

    const handleKakaoShare = () => { //카카오 공유하기 버튼
        try {
            window.Kakao.Link.sendDefault({
                objectType: 'feed',
                content: {
                    title: '비글즈 MBTI 반려짝궁 테스트에 초대합니다.',
                    description: '너는 내 DESTINY! 나의 운명의 반려짝꿍을 알아보자!',
                    imageUrl: 'http://d3u9cao110kbec.cloudfront.net/Community/Board/2022/10/2022-10-MBTI.png',
                    link: {
                        webUrl: window.location.href,
                    }
                },
                buttons: [{
                    title: '함께 해보기',
                    link: {
                        mobileWebUrl: window.location.href,
                        webUrl: window.location.href
                    }
                }],
            })
        }
        catch (err) {
            console.log("ERR : ", err)
            setPopModal(true);
            setPopText("ERR : ", err)
        }
    }

    const CopyToClipboard = () => { //URL 복사하기 버튼
        let temp = document.createElement("textarea");
        document.body.appendChild(temp);
        temp.value = window.location.href;
        temp.select();
        document.execCommand("copy");
        document.body.removeChild(temp);
        setPopModal(true);
        setPopText("결과 공유 링크를 복사했습니다.");
    }

    return (
        <div className="part3">
            <div className="result">
                <ResultComponent resultValue={resultValue} />
                <div className="share">
                    <h3>친구에게 반려짝꿍 공유하기</h3>
                    <ul>
                        <li>
                            <Link to="#" onClick={() => handleKakaoShare()}>
                                <img src={`${IMG_URL}/images/mbti/mbti_ic_kakao.png`} alt="mbti_ic_kakao.png" />
                            </Link>
                        </li>
                        <li>
                            <Link to="#" onClick={() => CopyToClipboard()}>
                                <img src={`${IMG_URL}/images/mbti/mbti_ic_share_url.png`} alt="mbti_ic_share_url.png" />
                            </Link>
                        </li>
                    </ul>
                </div>
                <div className="btn-area">
                    <Link to="/mbti" className="btn-retest">테스트 다시하기</Link>
                    <a href={getDownloadLink()} target="_blank" rel="noopener noreferrer" className="btn-down"><i></i>앱 다운로드</a>
                </div>
            </div>
            {/* <div className="tip">
                <dl>
                    <dt>확인해주세요!</dt>
                    <dd>공유 글에 본 이벤트와 관계없는 내용을 기재 시 추첨 내역에서 제외 될 수 있습니다.</dd>
                    <dd>당첨자는 당첨 발표일까지 비글즈 계정 팔로잉을 유지하는 고객을 대상으로 선정됩니다.</dd>
                    <dd>당첨 경품 수령 관련 상세 내용은 당첨 발표 시 안내될 예정이며, 안내에 따른 추가 정보 회신(메일)이 필요합니다.</dd>
                </dl>
            </div> */}
            {
                popModal &&
                <>
                    <div id="modal" className=""></div>
                    <div className="pop share">
                        <div className="txt">{popText}</div>
                        <div className="btn-area">
                            <Link to="#" onClick={() => setPopModal(false)} className="on">확인</Link>
                        </div>
                    </div>
                </>
            }
        </div>
    )
}

export default Result;